import { Procedure } from '@medplum/fhirtypes';
import { FC } from 'react';
import { getDisplayString } from '@medplum/core';
import { ResourceListSection } from '../shared/ResourceListSection';
import { ResourceListSectionConfig } from '../shared/ResourceListSectionConfig';
import { ProcedureListItem } from '../../../examination/procedures/ProcedureListItem';
import { mapProcedureToSurgeryInput } from '@/utils/surgery.utils';

// -----------------------------------------------------------------------------
export interface ProceduresProps {
  readonly procedures: Procedure[];
}

// -----------------------------------------------------------------------------
const procedureConfig: ResourceListSectionConfig<Procedure> = {
  titleKey: 'summaryPage.summary.procedures.title',
  noneKey: 'summaryPage.summary.procedures.none',
  noResourcesKey:
    'summaryPage.summary.procedures.procedureDisplay.noProcedures',

  sortResources: (procedures) =>
    [...procedures].sort((a, b) =>
      (b.performedDateTime ?? '').localeCompare(a.performedDateTime ?? '')
    ),

  getDisplayDate: (procedure) => procedure.performedDateTime ?? '',

  getDisplayName: (procedure) =>
    procedure.code?.coding?.[0]?.display ||
    procedure.code?.text ||
    getDisplayString(procedure),

  renderItem: (procedure) => (
    <ProcedureListItem
      procedure={mapProcedureToSurgeryInput(procedure)}
      hideActions
    />
  ),
};

// -----------------------------------------------------------------------------
export const Procedures: FC<ProceduresProps> = ({ procedures }) => {
  return (
    <ResourceListSection<Procedure>
      resources={procedures}
      config={procedureConfig}
    />
  );
};
